module.exports = __webpack_public_path__ + "img/primary_10x2_z18.aa57c3da.svg";